import { Checkbox } from '@aqarmap/aqarmap-ui';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { addListingDetailsType, ListingDetailsType } from '~addListing/types';

const MAX_AMENITY_LENGTH = 12;

const Amenities = ({ listing }: { listing: ListingDetailsType }) => {
  const { t } = useTranslation('app');
  const listingAmenities = listing?.amenities || [];
  const amenitiesData = listing?.property_type?.amenities || [];
  const sortedAmenities = [
    ...amenitiesData.map((item) => ({ key: item, value: t(item) })),
  ].sort((a, b) => a.value.length - b.value.length);

  const { setValue, watch, getValues } =
    useFormContext<addListingDetailsType>();

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: string,
  ) => {
    const checked = event.target.checked;
    const currentAmenities = getValues('amenities') || [];
    if (checked) {
      setValue('amenities', [...currentAmenities, item]);
    } else {
      setValue(
        'amenities',
        currentAmenities.filter((amenity) => amenity !== item),
      );
    }
  };

  useEffect(() => {
    setValue('amenities', listingAmenities);
  }, []);

  if (amenitiesData.length === 0) return null;

  return (
    <div className="flex flex-col gap-3x">
      <p className="text-title_2 text-black">{t('listingAmenities')}</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2x">
        {sortedAmenities.map((item) => {
          const isLong = item.value.length > MAX_AMENITY_LENGTH;

          return (
            <Checkbox
              key={item.key}
              field={{
                name: item.key,
                id: item.key,
                onChange: (event) => handleChange(event, item.key),
                checked: watch('amenities')?.includes(item.key) || false,
              }}
              size="medium"
              label={{
                text: item.value,
                className: 'text-body_1 !text-gray__dark_2',
              }}
              wrapperClassName={`!gap-x ${isLong ? 'col-span-2 md:col-span-1' : 'col-span-1'}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Amenities;
